import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Filter } from './filter.model';

@Injectable({
    providedIn: 'root',
})
export class FilterService {
    
    private filterChange = new Subject<any>();
    filter$ = this.filterChange.asObservable();

    filters: Filter

    constructor() {
        this.filters = new Filter({});
    }

    update(){
        this.filters.page = 0
        this.filterChange.next(this.filters)
    }

}
